"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogueAlert = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Icon_1 = require("../Icon");
var Dialogue_1 = require("./Dialogue");
var DialogueAlert = function (props) {
    var attributes = {
        closeModal: props.callbackAffirmative,
        closeOnClick: false,
        closeOnEsc: false,
        fade: props.fade,
        id: props.id,
        isOpen: props.isOpen,
        message: props.message,
        title: props.title,
    };
    // tslint:disable no-string-literal
    attributes['icon'] = {
        element: (React.createElement(Icon_1.Icon, { symbol: "messageAlert64" })),
        height: 64,
        width: 64,
    };
    attributes['buttonDefault'] = {
        children: props.textAffirmative || 'OK',
        onClick: props.callbackAffirmative,
    };
    if (props.textDismissive) {
        attributes['buttonSubtle'] = {
            children: props.textDismissive,
            onClick: props.callbackDismissive,
        };
    }
    // tslint:enable no-string-literal
    return (React.createElement(Dialogue_1.Dialogue, __assign({}, attributes), props.children));
};
exports.DialogueAlert = DialogueAlert;
exports.DialogueAlert.defaultProps = {
    fade: false,
};
exports.DialogueAlert.propTypes = {
    callbackAffirmative: PropTypes.func.isRequired,
    callbackDismissive: PropTypes.func,
    children: PropTypes.element,
    fade: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    message: PropTypes.string,
    textAffirmative: PropTypes.string,
    textDismissive: PropTypes.string,
    title: PropTypes.string.isRequired,
};
